import app from 'flarum/forum/app';
import LogInModal from 'flarum/forum/components/LogInModal';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import { extend, override } from 'flarum/common/extend';
import Stream from 'flarum/common/utils/Stream';
import { buildRedeemBody, submitRegistration } from './registrationCodeForm';

app.initializers.add('yingtao-registration-codes-forum', () => {
  override(SignUpModal.prototype, 'oninit', function (original, vnode) {
    original(vnode);
    this.registrationCode = Stream('');
  });

  extend(SignUpModal.prototype, 'fields', function (items) {
    const registrationCodeLabel = '注册码';

    items.remove('email');
    items.add(
      'registrationCode',
      <div className="Form-group">
        <input
          className="FormControl"
          name="registrationCode"
          type="text"
          autocomplete="off"
          placeholder={registrationCodeLabel}
          aria-label={registrationCodeLabel}
          bidi={this.registrationCode}
          disabled={this.loading}
          required
        />
      </div>,
      20
    );
  });

  override(SignUpModal.prototype, 'onsubmit', function (_original, event) {
    event.preventDefault();
    this.loading = true;

    const signUpData = this.submitData();
    const password = signUpData.password;
    const errorHandler = this.onerror.bind(this);

    submitRegistration({
      request: (options) => app.request(options),
      login: (params, options) => app.session.login(params, options),
      reload: () => window.location.reload(),
      loaded: this.loaded.bind(this),
      errorHandler,
      requestOptions: {
        url: app.forum.attribute('apiUrl') + '/yingtao/registration-codes/redeem',
        method: 'POST',
        body: buildRedeemBody(this.registrationCode(), signUpData),
      },
      password,
    });
  });

  override(LogInModal.prototype, 'onsubmit', function (_original, event) {
    event.preventDefault();
    this.loading = true;

    app
      .request({
        method: 'POST',
        url: app.forum.attribute('baseUrl') + '/yingtao-login',
        body: this.loginParams(),
        errorHandler: this.onerror.bind(this),
      })
      .then(() => window.location.reload(), this.loaded.bind(this));
  });
});
